import styled, { createGlobalStyle } from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const FixedPlusWrapper = styled.div`
  position: sticky;
  top: 0;
  right: 20px;
  z-index: 10;
  pointer-events: none;
  margin-left: 20px;
`

export const PlusButtonWrapper = styled.button`
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: none;
  background: ${COLORS.primaryDark};
  box-shadow: 0px 4px 4px rgba(56, 125, 255, 0.24);
  transition: background 0.3s ease;
  cursor: pointer;

  &:hover {
    background: ${COLORS.primaryExtraDark};
  }

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
`

export const PlusButtonGlobalStyles = createGlobalStyle`
  .plus-button-flyout {
    border-radius: 8px
  }
`
